var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isShowingFirstScreen)?_c('v-layout',{class:['button-group', ("button-group" + (_vm.isSticky ? '-sticky' : ''))]},[(!_vm.contentGenerated)?_c('ButtonGroup',{attrs:{"primaryBtnText":_vm.primaryBtnText},on:{"primaryClicked":_vm.handlePrimaryClick,"secondaryClicked":_vm.handleSecondaryClick}}):_vm._e(),_vm._v(" "),(_vm.contentGenerated)?_c('GeneratedContentInfoBar'):_vm._e()],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1299b3c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/searchAi/SearchAIFooter.vue
// module id = null
// module chunks = 